export default __webpack_public_path__ + "static/media/landscape7.d0e5129e.jpg";